import { useState } from "react";
import { Panel } from "../../components/ui";

const FaqRow = ({ faq, open, onToggle }) => (
  <li className="border-b border-slate-100 last:border-0">
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      className="flex w-full items-center justify-between gap-3 bg-transparent px-0 py-3 text-left"
    >
      <span className="text-sm font-medium text-slate-900">{faq.question}</span>
      <span className="text-slate-400 text-xs">{open ? "−" : "+"}</span>
    </button>
    {open ? (
      <p className="text-sm text-slate-600 m-0 pb-3 whitespace-pre-line">{faq.answer}</p>
    ) : null}
  </li>
);

/**
 * The office's own answers, from the Referral module's FAQ. Absent until they have written one,
 * because a heading over nothing reads as a broken page and the thread to a person is right there.
 */
const FaqPanel = ({ faqs }) => {
  const [openId, setOpenId] = useState(null);

  if (!faqs?.length) return null;

  return (
    <Panel title="Common questions" className="lg:col-span-2">
      <ul className="list-none p-0 m-0">
        {faqs.map((faq) => (
          <FaqRow
            key={faq.id}
            faq={faq}
            open={openId === faq.id}
            onToggle={() => setOpenId(openId === faq.id ? null : faq.id)}
          />
        ))}
      </ul>
    </Panel>
  );
};

export default FaqPanel;
